module.exports = __webpack_public_path__ + "static/media/haiwaizhuzhanrenyuanguanlizhidu.2baca03a.png";